exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".questionnaire-subhead[data-v-341f2ecd]{padding:.1rem 1rem;font-size:1.2rem;border:1px solid #000;background-color:#ffffc1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-341f2ecd&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/subPages/Order/Form.vue
// module id = 502
// module chunks = 0